<template>
  <div class="side-bar" id="side-bar">
    <div class="side-up">
      <el-menu
      default-active="2"
      :default-openeds='open_list'
      router
      class="el-menu-vertical-demo"
      @open="handleOpen"
      @close="handleClose"
      :collapse="isCollapse"
      :unique-opened="true"
      active-text-color="#fffffd"
      :class="[isCollapse==false?'open':'fold']"
      >
        <template v-for="(item,ind) in navList">
          <el-menu-item
            :index="item.name"
            v-if="!item.child"
            :class="[item.active==true?'active':'']"
            @click="select(item.navItem,1)"
            :key="ind"
          >
            <template>
              <i class="icon-menu"></i>
              <span>{{item.navItem}}</span>
            </template>
          </el-menu-item>
          <el-submenu :index="(ind+1)+''" :class="[item.active==true?'active':'']" :key="ind" v-else @click="select(item.navItem)">
            <template slot="title">
              <i
                :class="{'icon-one': ind == 1,'icon-two': ind == 2,'icon-three': ind == 3,'icon-four': ind == 4,'icon-five': ind == 5 || is_customer==1,'icon-six': ind == 6,'icon-seven': ind == 7}"
              ></i>
              <span slot="title">{{item.navItem}}</span>
            </template>
            <el-menu-item
              v-for="(subItem, subIndex) in item.child"
              :index="subItem.name"
              :key="subIndex"
              @click="select(subItem.navItem)"
              :class="[subItem.active==true?'active':'']"
            >
              <span>{{ subItem.navItem }}</span>
            </el-menu-item>
          </el-submenu>
        </template>
        <!-- <el-radio-group v-model="isCollapse" v-if="is_customer==1" style="margin-bottom: 20px;">
          <div>
            <el-radio-button :label="!isCollapse">
              <i class="bc-icon"></i>
            </el-radio-button>
          </div>
        </el-radio-group> -->
        <el-radio-group v-model="isCollapse" v-if="type=='新'" :disabled="type=='新'" style="display:none;margin-bottom: 20px;">
          <div>
            <el-radio-button :label="!isCollapse">
              <i class="bc-icon"></i>
            </el-radio-button>
          </div>
        </el-radio-group>
        <el-radio-group v-model="isCollapse" v-else style="margin-bottom: 20px;">
          <!-- <div>
            <el-radio-button :label="!isCollapse">
              <span style="">
                <i class="bc-icon" @click="toParent($event)"></i>
              </span>
            </el-radio-button>
          </div> -->
          <div>
            <el-radio-button :label="!isCollapse">
              <i class="bc-icon"></i>
            </el-radio-button>
          </div>
        </el-radio-group>
      </el-menu>
    </div>
  </div>
</template>

<script>
import Bus from '../assets/js/bus.js'
export default {
  
  data() {
    return {
      is_customer:"",
      isCollapse: true,
      input: "",
      props: ["routes"],
      defaultUrl: "/homePage",
      open_list: [],//刷新页面之后默认展开
      currentMenu:"",
      active: false,
      navList:[],
      type:"",
      sideBarHeight:"",//左侧栏高度
      navListDefault: [
        { name: "/homePage", navItem: "运营总览",active:false },
        {
          name: "",
          navItem: "实时监控",
          active:false,
          child: [
            {
              name: "/realTimeMonitoring/equipmentMonitoring",
              navItem: "设备监控",
              active:false
            },
            {
              name: "/realTimeMonitoring/videoMonitoring",
              navItem: "视频监控",
              active:false
            },
            {
              name: "/realTimeMonitoring/electricityMonitoring",
              navItem: "用电监控",
              active:false
            }
          ]
        },
        {
          name: "",
          navItem: "经营分析",
          active:false,
          child: [
            {
              name: "/dataAnalysis/chargingRevenue",
              navItem: "充电收入",
              active:false
            },
            {
              name: "/dataAnalysis/fundRecord",
              navItem: "资金管理",
              active:false
            },
            {
              name: "/dataAnalysis/operationAnalysis",
              navItem: "运营报告",
              active:false
            }
          ]
        },
        {
          name: "",
          navItem: "场站管理",
          active:false,
          child: [
            {
              name: "/stationManagement/electricityPayment",
              navItem: "电费缴纳",
              active:false
            },
            {
              name: "/stationManagement/deviceManagement",
              navItem: "设备管理",
              active:false
            },
            {
              name: "/stationManagement/taskManagement",
              navItem: "合约管理",
              active:false
            },
            {
              name: "/stationManagement/stationList",
              navItem: "场站列表",
              active:false
            }
          ]
        },
        {
          name: "",
          navItem: "充电管理",
          active:false,
          child: [
            {
              name: "/chargeManagement/chargingRecord",
              navItem: "充电记录",
              active:false
            },
            {
              name: "/chargeManagement/chargingTemplate",
              navItem: "计费模板",
              active:false
            },
            {
              name: "/chargeManagement/interConnect",
              navItem: "互联互通",
              active:false
            }
          ]
        },
        {
          name: "",
          navItem: "会员管理",
          active:false,
          child: [
            {
              name: "/membershipManagement/membershipData",
              navItem: "会员数据",
              active:false
            },
            {
              name: "/membershipManagement/groupCustomer",
              navItem: "集团客户",
              active:false
            },
            {
              name: "/membershipManagement/invoiceissueData",
              navItem: "发票记录",
              active:false
            },
          ]
        },
        {
          name: "",
          navItem: "运维管理",
          active:false,
          child: [
            {
              name: "/operationManagement/taskManage",
              navItem: "任务管理",
              active:false
            },
            {
              name: "/operationManagement/alarmManagement",
              navItem: "告警管理",
              active:false
            }
          ]
        },
        {
          name: "",
          navItem: "系统管理",
          active:false,
          child: [
            {
              name: "/systemManagement/privilegeManagement",
              navItem: "访问管理",
              active:false
            },
            {
              name: "/systemManagement/businessManagement",
              navItem: "企业管理",
              active:false
            },
            {
              name: "/systemManagement/systemLog",
              navItem: "系统日志",
              active:false
            }
          ]
        }
      ]
    };
  },
  watch:{
    clientHeight (val) {
      // console.log(val);
    }
  },
  mounted() {
    


    let href = window.location.href;
    this.defaultUrl = href.split("/#")[1];
    let getItem = localStorage.getItem("pathName");
    for(let i in this.navList){
      if(this.navList[i].navItem == getItem){
        this.navList[i].active = true;
      } else {
        this.navList[i].active = false;
      }
      if(this.navList[i].child){
        for(let j in this.navList[i].child){
          if(this.navList[i].child[j].navItem == getItem){
            this.navList[i].child[j].active = true;
          } else {
            this.navList[i].child[j].active = false;
          }
        }
      }
    }
    this.type = localStorage.getItem("type");
    // console.log(this.type);
    this.is_customer = localStorage.getItem("is_customer");
    if(localStorage.getItem("type") == "新"){
      this.navList = [];
    } else if(localStorage.getItem("type") == "旧"){
      if(localStorage.getItem("is_customer") == 1){
      this.navList = [
        { name: "", navItem: "会员管理", active:false,
          child: [
            {
              name: "/membershipManagement/gCustomer",
              navItem: "集团客户",
              active:false
            }
          ]
        },
      ]
    } else {
      // console.log(this.$store.state.role);
      let role = [];
      role = this.$store.state.role;
      for(let i in role){
        for(let j in this.navListDefault){
          if(this.navListDefault[j].navItem == role[i].view_name && role[i].view_name == "运营总览"){
            this.navList.push(this.navListDefault[j]);
          } else if(this.navListDefault[j].navItem == role[i].view_name){
            this.navList.push({
              name: "",
              navItem: this.navListDefault[j].navItem,
              active:false,
              child: []
            });
            for(let m in role[i].chlid){
              for(let n in this.navListDefault[j].child){
                if(this.navListDefault[j].child[n].navItem == role[i].chlid[m].view_name){
                  for(let o in this.navList){
                    if(this.navList[o].navItem == role[i].view_name){
                      this.navList[o].child.push(this.navListDefault[j].child[n]);
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
      // console.log(this.navList);
    }
    
    //获取窗口可视化高度
    this.$nextTick(function() {
      // console.log(document.documentElement.clientHeight);
    });
  },
  computed:{
    isChangeMsg(){
      return this.$store.state.collapse;
    },
    isSideBarHeight(){
      // console.log(this.$store.state.sideBarHeight);
      return this.sideBarHeight;
    },
  },
  watch:{
    "isCollapse":function(newVal,oldVal){
      // debugger
      // this.pub.setMessage(this.isCollapse);
      // console.log(this.isCollapse);
      this.$store.commit("changeMsg",this.isCollapse);
      this.$emit("event",this.isCollapse);
      Bus.$emit('msg', this.isCollapse);
      // this.$store.commit("changeMsg",this.isCollapse);
      if(this.isCollapse == true){
        document.querySelector(".side-bar").style.width="46px";
        document.querySelector(".side-up").style.width="66px";
      } else {
        document.querySelector(".side-bar").style.width="150px";
        document.querySelector(".side-up").style.width="170px";
      }
      // document.querySelector(".el-radio-button__orig-radio").style.display = "none";
    },
    $route(to,from){
    },
    "isSideBarHeight":function(newVal,oldVal){
    },
    '$route.path': function (newVal, oldVal) {
    }
  },
  created(){
    //刷新页面之后默认展开
    this.open_list = [];
    // console.log(this.open_list);
    this.getUrl();
    // console.log(this.currentMenu);
    let open_list = 0;
    for(let i in this.navList){
      for(let j in this.navList[i].child){
        // if(this.navList[i].child[j].name == this.currentMenu){
        //   this.open_list.push((+i+1).toString());
        // }
        if(this.navList[i].child[j].navItem == this.currentMenu){
          this.open_list.push((+i+1).toString());
          this.$router.push(this.navList[i].child[j].name);
        }
      }
    }
  },
  methods: {
    handleOpen(key, keyPath) {
      // console.log(key, keyPath);
    },
    handleClose(key, keyPath) {
      // console.log(key, keyPath);
    },
    toParent(event){
      // console.log(event.target);
      // console.log(this.isCollapse);

      // this.$emit("event",this.isCollapse);
      // Bus.$emit('msg', this.isCollapse);
      // // this.$store.commit("changeMsg",this.isCollapse);
      // if(this.isCollapse == false){
      //   document.querySelector(".side-bar").style.width="46px";
      //   document.querySelector(".side-up").style.width="66px";
      // } else {
      //   document.querySelector(".side-bar").style.width="150px";
      //   document.querySelector(".side-up").style.width="170px";
      // }
    },
    bus() {
      Bus.$emit('msg', this.isCollapse);
    },
    select(e,data) {
      // debugger
      localStorage.setItem("pathName", e);
      for(let i in this.navList){
        if(this.navList[i].navItem == e){
          this.navList[i].active = true;
        } else {
          this.navList[i].active = false;
        }
        if(this.navList[i].child){
          for(let j in this.navList[i].child){
            if(this.navList[i].child[j].navItem == e){
              this.navList[i].child[j].active = true;
            } else {
              this.navList[i].child[j].active = false;
            }
          }
        }
      }
      if(data == 1){
        this.open_list = [];
      }
    },
    getUrl(){
      let self = this;
      // let currentUrl = window.location.href;
      // self.currentMenu = currentUrl.split('#')[1];
      self.currentMenu = localStorage.getItem("pathName");
    }
  }
};
</script>

<style scoped lang="scss">
::-webkit-scrollbar {
  display: none;
} 
.side-bar {
  width: 46px;
  overflow: hidden;
  position: fixed;
  left: 0;
  top:60px;
  // margin-top: 60px;
  z-index: 99;
  .el-menu {
    border-right: none;
  }
  .isActive {
    color: #fffffd !important;
  }
  .side-up {
    width: 66px;
    height: 100%;
    overflow-y: scroll;
  }
}
// .side-bar {
//   // height: 100%;
//   position: fixed;
//   left: 0;
//   top:60px;
//   // margin-top: 60px;
//   z-index: 99;
//   .el-menu {
//     border-right: none;
//   }
//   .isActive {
//     color: #fffffd !important;
//   }
//   .side-up {
//     width: 100%;
//     height: 100%;
//     overflow-y: scroll;
//   }
// }
</style>
<style lang="scss">
.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 150px;
  padding-bottom: 60px;
}
.el-menu-vertical-demo.el-menu--collapse {
  width: 46px;
  padding-bottom: 60px;
}
.side-bar {
  height: 100%;
  background-color:#191b21;
  .el-radio-button__orig-radio {
    display: none;
    bottom: -100px;
    outline: none;
  }
  .el-submenu__icon-arrow {
    right:22px;
  }
  .el-menu {
    background-color: #191b21;
    .el-submenu__title {
      span {
        color: #ADADAB;
        padding-left: 4px;
      }
    }
    .el-menu-item {
      border-bottom:1px solid #16181e;
      border-right:none;
      span {
        color: #ADADAB;
        padding-left: 4px;
      }
    }
    .el-menu-item.active {
      background-color: #191b21;
      span {
        color: #fffffd;
      }
      i {
        background: url( ../assets/img/icon.png) -64px 0 no-repeat;
      }
    }
    .el-submenu {
      ul {
        .el-menu-item {
          padding:0 !important;
          min-width: none !important;
        }
      }
    }
    .el-submenu.active {
      span {
        color: #fffffd;
      }
      .icon-one {
        background: url( ../assets/img/icon.png) -68px -25px no-repeat;
      }
      .icon-two {
        background: url( ../assets/img/icon.png) -66px -53px no-repeat;
      }
      .icon-three {
        background: url( ../assets/img/icon.png) -66px -82px no-repeat;
      }
      .icon-four {
        background: url( ../assets/img/icon.png) -66px -111px no-repeat;
      }
      .icon-five {
        background: url( ../assets/img/icon.png) -65px -133px no-repeat;
      }
      .icon-six {
        background: url( ../assets/img/icon.png) -64px -162px no-repeat;
      }
      .icon-seven {
        background: url( ../assets/img/icon.png) -64px -191px no-repeat;
      }
    }
  }
  .icon-menu {
    display: inline-block;
    width: 20px;
    height: 15px;
    background: url( ../assets/img/icon.png) -25px 0 no-repeat;
    margin-right:8px;
  }
  .icon-one {
    display: inline-block;
    width: 20px;
    height: 18px;
    background: url( ../assets/img/icon.png) -25px -25px no-repeat;
    margin-right:8px;
  }
  .icon-two {
    display: inline-block;
    width: 20px;
    height: 19px;
    background: url( ../assets/img/icon.png) -25px -53px no-repeat;
    margin-right:8px;
  }
  .icon-three {
    display: inline-block;
    width: 20px;
    height: 19px;
    background: url( ../assets/img/icon.png) -25px -82px no-repeat;
    margin-right:8px;
  }
  .icon-four {
    display: inline-block;
    width: 20px;
    height: 12px;
    background: url( ../assets/img/icon.png) -25px -111px no-repeat;
    margin-right:8px;
  }
  .icon-five {
    display: inline-block;
    width: 17px;
    height: 19px;
    background: url( ../assets/img/icon.png) -24px -133px no-repeat;
    margin-right:8px;
  }
  .icon-six {
    display: inline-block;
    width: 19px;
    height: 19px;
    background: url( ../assets/img/icon.png) -24px -162px no-repeat;
    margin-right:8px;
  }
  .icon-seven {
    display: inline-block;
    width: 19px;
    height: 19px;
    background: url( ../assets/img/icon.png) -24px -191px no-repeat;
    margin-right:8px;
  }
}
.el-radio-group {
  float: left;
  span {
    border:none;
  }
  .bc-icon {
    display: inline-block;
    width: 23px;
    height: 19px;
    background: url(../assets/img/icon.png) right top no-repeat;
    z-index: 10;
  }
}
.el-radio-button__inner {
  background-color: #191b21 !important;
  padding: 12px 10px !important;
  outline: none;
}
.el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0px !important;
  border-left:0 !important;
  outline: none;
}
.el-menu-item:focus, .el-menu-item:hover {
  outline: 0;
  background-color: #191b21;
}
.el-submenu__title:hover {
    background-color: #191b21;
}
.el-menu  {
  background-color: #191b21 !important;
}
.el-menu li {
  color: #ADADAD !important;
}
.el-menu .el-submenu .el-submenu__title {
  color: #ADADAD !important;
}
.el-submenu .el-menu-item {
  min-width: 0 !important;
}
.el-menu .el-submenu ul li {
  color: #ADADAD !important;
}
.el-menu-item:focus, .el-menu-item:hover {
  background-color: #0777BB !important;
}
.side-bar .el-menu .el-menu-item:hover span {
    color: #fffffd !important;
}
.el-submenu .el-submenu__title:hover {
  background-color: #0777BB !important;
}
.side-bar .el-menu .el-submenu ul .el-menu-item {
  text-align:center;
}
.open {
  text-align:left;
}
.fold {
  text-align:left;
}
.el-submenu__title,.el-menu-item {
  padding: 0 12px !important;
}
.el-menu-item div {
  padding: 0 12px !important;
}
.el-menu--popup {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/sidebar.vue